import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
    Layout,
    theme,
    Input,
    Row,
    Typography,
    Card,
    Select,
    Collapse,
    Form,
    Checkbox,
    Spin,
    Col,
    InputNumber,
    Divider,
    DatePicker,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";

//PROJECT IMPORTS
import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import CustomButton from "../../../../components/custom/CustomButton";
import TextArea from "antd/lib/input/TextArea";
import TopContent from "../../../../components/layouts/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import { fxRateTypeSetupAPI, fxRateTypeSetupLabel, fxRateTypeSetupStatic } from "../ManageFxRate.config";

const { Text, Title } = Typography;

const EditPRD0601 = (props) => {
    //DECLARED VARIABLES
    const {
        userData
    } = props;
    const { session } = userData;
    const { state } = useLocation();
    const navigate = useNavigate();
    const [useForm] = Form.useForm();
    const [status, setStatus] = useState(true);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        //ACTIVATE SAVE RIGHTSIDEBAR ACTION
        // dispatch({
        //   type: cnt.RIGHT_SAVE_BTN,
        // });
        setIsLoading(false);
        getDetailById();
    }, []);


    const getDetailById = () => {
        setIsLoading(true);

        const url = `${fxRateTypeSetupAPI.FxRateTypes}/${state.key}`;

        let body = {
            session,
        };

        /** FETCH ROLE */
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            } else {
                const objDetail = res;

                // SHOW THE SAVED DATA
                useForm.setFieldsValue({
                    name: objDetail.name,
                    code: objDetail.code,
                });

                // setStatus(objDetail?.recordStatus)
                setIsLoading(false);
            }
        });
    };

    function onCancel() {
        navigate("/prd0601", { replace: false });
    }

    const onSubmit = (formValues) => {
        const url = `${fxRateTypeSetupAPI.FxRateTypes}/${state.key}`;

        // formValues.status = status

        const body = {
            ...formValues,
            method: "PUT",
            session,
        };

        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
            } else {
                BOM.AlertMsg(cnt.SUCCESS, fxRateTypeSetupLabel.editFXRateTypeMsg);
                navigate("/prd0601");
                //STOP LOAD
                setIsLoading(false);
            }
        });
    };

    return (
        <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
            <TopContent
                pageTitle={fxRateTypeSetupLabel.editFxRateType}
                pageItems={fxRateTypeSetupStatic.editFxRateTypeItems}
            />
            <Spin spinning={isLoading} size="large">
                <Card
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}
                >
                    <Form
                        initialValues={{
                            active: true,
                            isPenalty: false,
                        }}
                        form={useForm}
                        layout="vertical"
                        onFinish={onSubmit}
                    >
                        <Row>
                            <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                                {fxRateTypeSetupLabel.fxRateSetUp}
                            </Title>
                        </Row>
                        <Divider style={{ marginTop: 10, marginBottom: 30 }} />
                        <Row>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={fxRateTypeSetupLabel.code}
                                    name="code"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(
                                                fxRateTypeSetupLabel.code
                                            ),
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(fxRateTypeSetupLabel.code)}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={fxRateTypeSetupLabel.name}
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(
                                                fxRateTypeSetupLabel.name
                                            ),
                                        },
                                    ]}
                                >
                                    <TextArea
                                        placeholder={BOM.handlePlaceholderMsg(fxRateTypeSetupLabel.name)}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={fxRateTypeSetupLabel.status}
                                    name="status"
                                >
                                    <Checkbox
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${fxRateTypeSetupLabel.status} *`,
                                            "select"
                                        )}
                                        checked={status}
                                        disabled
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row>
                            <Divider />
                            {BOM.HasPermission("UPDATE_RATE_TYPE") && <CustomButton
                                content="Submit"
                                style={{
                                    width: "10%",
                                    marginLeft: "auto",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                htmlType="submit"
                                backgroundColor="#92428B"
                                colorText="white"
                                hoverBackground="#AD4EA7"
                            />}
                            <CustomButton
                                content="Cancel"
                                style={{
                                    width: "10%",
                                    marginLeft: "1%",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                backgroundColor="#fff"
                                colorText="black"
                                hoverBackground="#F5F5F5"
                                onClick={onCancel}
                            />
                        </Row>
                    </Form>
                </Card>
            </Spin>
        </MainLayout>
    );
};

const mapStateToProps = (state) => ({
    userData: state.AuthenticationData.userData,
    rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(EditPRD0601);
